import {
  Box,
  Card,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import LoadingComponent from 'src/app/components/Loading';
import { Pagination } from '@material-ui/lab';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { useTheme, useMediaQuery } from '@material-ui/core';

const StatisticDeviceActiveTable = ({
  listDeviceActive,
  totalActive,
  getListDeviceActiveRef,
  params,
  setParams
}) => {
  const isLoading = useSelector(state => state.statisticSlice.isLoading);
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const limit = isMobile ? 4 : PAGE_SIZE_LIST;

  const handlePageChange = (event, newPage) => {
    if (!getListDeviceActiveRef) return;
    const newparams = Object.assign({}, params, { page: newPage });
    setParams(newparams);
    getListDeviceActiveRef(newparams);
  };

  return (
    <>
      <Card className={classes.root}>
          <div>
            <PerfectScrollbar>
              {listDeviceActive && listDeviceActive.length ? (
                <Box style={{ overflowX: 'auto' }} minWidth={1050}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Ngày kích hoạt</TableCell>
                        <TableCell>Mã thiết bị</TableCell>
                        <TableCell>Serial</TableCell>
                        <TableCell>Phiên bản</TableCell>
                        <TableCell>Đại lý</TableCell>
                        <TableCell>Người dùng</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listDeviceActive.map((data, index) => (
                        <TableRow hover key={data?.id}>
                          <TableCell>
                            {data?.active_at
                              ? moment(data.active_at).format('DD-MM-yyyy')
                              : '-'}
                          </TableCell>
                          <TableCell>
                            {data?.deviceType?.name || '--'}
                          </TableCell>
                          <TableCell>{data?.serial || '--'}</TableCell>
                          <TableCell>
                            {data?.hardware_version || '--'}
                          </TableCell>
                          <TableCell>{data?.agency?.name || '--'}</TableCell>
                          <TableCell>
                            {data?.end_user?.user?.full_name || '--'}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              ) : (
                <div className="text-center pb-5">
                  <img
                    src="/static/empty.png"
                    className="justify-content-center"
                  />
                  <h4> Danh sách trống </h4>
                </div>
              )}
            </PerfectScrollbar>
          </div>
      </Card>
      {listDeviceActive && listDeviceActive?.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'15px'}}>
            <Typography style={{ fontSize:'14px'}}>Tổng: {totalActive}</Typography>
          <Pagination
              count={Math.ceil(totalActive / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page) || 1}
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 1 : 2}
              showFirstButton={!isMobile}
              showLastButton={!isMobile}
            />
          </Box>
        </div>
      )}
    </>
  );
};

const useStyles = makeStyles(theme => ({
 root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default StatisticDeviceActiveTable;
